import First from "../../../../../assets/images/project/rumah/YDI_HOUSE/rumah_ydi_house.jpg";

export default [
  {
    title: "YDI House",
    description: "Rumah modern minimalis",
    urls: First,
  },
];
